export default {
  customBackground: {
    label: 'Custom',
    hint: 'JPEG · PNG · max 5 MB',
    uploadAriaLabel: 'Upload custom background',
    replaceAriaLabel: 'Replace background image',
    previewAlt: 'Background preview',
    savedAlt: 'Saved background',
    save: 'Save',
    change: 'Change',
    cancel: 'Cancel',
    replace: 'Replace',
    saving: 'Saving…',
    errorTitle: 'Upload failed',
    errorType: 'Only JPEG and PNG images are accepted.',
    errorSize: 'File exceeds the 5 MB limit. Please choose a smaller image.',
    errorSave: 'Could not save the image. Please try again.',
    errorUnknown: 'Invalid file. Please try again.',
  },
};
